import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Podcast from '../components/Podcast';
import CoreValues from '../components/CoreValues';
import Salvation from '../components/Salvation';
import Mission from '../components/Mission';
import News from '../components/News';

export default function LadyP() {
  return (
    <div>
      <Header />

      <hr className="g-brd-gray-light-v4 my-0" />

      <main>
        {/* Lady P Section */}
        <section className="g-flex-centered g-bg-darkgray-radialgradient-circle g-color-white-opacity-0_7 g-py-55">
          <div className="container">
            <div className="row">
              {/* Text */}
              <div className="col-md-6 align-self-center g-py-20">
                <h2 className="h4 text-uppercase g-letter-spacing-1 g-mb-10">
                  Priscilla &quot;Lady P&quot; Guillory-Brown
                </h2>
                <p className="g-font-size-13 text-uppercase g-color-white-opacity-0_8 g-mb-15">
                  First Lady of Zion Tabernacle Church
                </p>
                <p className="lead mb-0 g-line-height-2">
                  Priscilla &quot;Lady P&quot; Guillory-Brown is the wife of Bishop
                  K.J. Brown, founder of Zion Tabernacle Church and Bishop K.J. Brown
                  Ministries. Together, Lady P and Bishop Brown are the proud parents of
                  two daughters, Kristina and Kayla.
                  <br />
                  <br />
                  Serving under the leadership of her husband, Lady P is an ordained
                  minister and serves as the Director of Women&apos;s and Children&apos;s
                  Ministries at Zion Tabernacle Church. She holds an Associate&apos;s
                  Degree in Fashion Merchandising and works professionally as a Certified
                  Nursing Assistant.
                  <br />
                  <br />
                  Lady P is a passionate woman of God, known for speaking life and
                  encouragement into those around her. In her spare time, she loves
                  thrifting and home décor. <strong>Prisca Gifts</strong> is an extension
                  of Lady P&apos;s love for fashion, unique finds, and blessing others
                  through her creativity.
                  <br />
                  <br />
                  We pray you are encouraged and inspired by her ministry. And remember,
                  “God wants you to win.”
                </p>
              </div>

              {/* Image */}
              <div className="col-md-6 align-self-center g-py-20">
                <img
                  className="w-100"
                  src="/images/prisciila.jpg"
                  alt="Priscilla “Lady P” Guillory-Brown"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Shared sections */}
        <Podcast />
        <CoreValues />
        <Salvation />
        <Mission />
        <News />
      </main>

      <Footer />
    </div>
  );
}
